import styled from "styled-components";
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
`;

export const QuestaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const OpcaoContainer = styled.div`
  display: flex;
  margin-bottom: 16px;

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const SaveContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const ContainerInputSearch = styled.div`
  display: flex;

  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }
`;

export const Redirect = styled.a`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const TableButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;
  padding-left:250px;

  margin: 6% auto;

  & > *:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;

  & > *:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const SectionTitle = styled.h3`
  width: max-content;
  cursor: pointer;
`;

export const SubSectionTitle = styled.h4`
  font-size: 24px;
`;

export const SubsubSectionTitle = styled.h5`
  font-size: 16px;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin-right: 0.3rem;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const Checkbox = styled.input`
  width: max-content;
`;

export const Label = styled.label`
  font-weight: 500;
  font-size: 12px;
`;

export const Fieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: ${(props) => props?.direction || "column"};

  ${(props) =>
    props.direction === "row" &&
    `
  
  > :not(:last-child) {
    margin-right: 16px;
  }

  `}

  ${(props) =>
    props.direction !== "row" &&
    `
  
  > :not(:last-child,:first-child) {
    margin-bottom: 16px;
  }

  `}

${(props) =>
    props.changed &&
    `
  border: 2px solid rgba(0,0,255, 0.5);
  padding: 4px;
`}
`;

export const Image = styled.img`
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
`;

export const Iframe = styled.iframe`
  min-height: 480px;
`;

export const SubSection = styled.section`
  margin-bottom: 48px !important;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }

  /* border: 1px solid #cecece; */
`;

export const SubSectionList = styled.div``;

export const SubsubSection = styled.section`
  margin-bottom: 32px !important;
  margin-top: 16px !important;
  padding: 16px !important;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }

  /* border: 1px solid #eee; */
`;

export const SubsubSectionList = styled.div``;

export const FieldsetContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: ${(props) => (props.active !== false ? "max-content" : "0")};

  /* overflow-y: hidden; */

  transition: 0.5s all ease-in-out;

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const SubSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: ${(props) => (props.active !== false ? "max-content" : "0")};

  /* overflow-y: hidden; */

  transition: 0.5s all ease-in-out;
`;

export const FixedBottomContainer = styled.footer`
  position: fixed;
  left: 0;
  bottom: 0;
  height: 80px;
  width: 100%;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  background-color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 32px;
  }
`;

export const AcademyChange = styled.div`
  > section {
    padding: 8px;

    > p {
      font-size: 12px;
    }
  }

  > section:first-of-type {
    background-color: rgba(255, 0, 0, 0.25);
  }

  > section:last-of-type {
    background-color: rgba(0, 255, 0, 0.25);
  }

  > h1 {
    font-size: 16px;
    margin: 0;
  }

  > :not(:last-child) {
    margin-bottom: 8px;
  }
`;
